/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'../../../../filters/dock/ActiveFilterIndicator'
], function (
	View,
	$,
	ActiveFilterIndicator
) {
	class ActiveFilterView extends View {
		constructor(options) {
			super(options);
			this._container = options.containerNode;
			this._dashboard = options.dashboardAPI;
			this._attachedEvents = [];
			this._registerEvents();
		}

		init(options) {
			super.init(options);
		}

		_registerEvents() {
			this._attachedEvents.push(this._dashboard.on('tab:tabChanged', this._onScopeChanged, this));
			this._attachedEvents.push(this._dashboard.on('pagecontext:filterContextUpdated', this._onFilterContextUpdated, this));
		}

		render() {
			const internalInteractionController = this._dashboard.getFeature('InteractionController.internal');
			if (!internalInteractionController) {
				return;
			}

			const currentSelectedTabId = internalInteractionController.boardModel.getSelectedLayout();
			const pageContextAPI = this._dashboard.getFeature('PageContextService').getPageContext();
			this._afi = new ActiveFilterIndicator({
				scopes: {
					tabScope: currentSelectedTabId,
					globalScope: 'global'
				},
				pageContextAPI: pageContextAPI,
				animate: false
			});
			$(this._container).append(this._afi.getNode());
			this._afi.show(true);
		}

		remove() {
			this._attachedEvents && this._attachedEvents.forEach(event => event && event.remove());
			if (this._afi) {
				this._afi.remove();
				this._afi = null;
			}
		}

		/**
		 * Method to react to the tab scope changing, and updating the scope accordingly
		 * The tab scope needs to be updated to determine the correct number of active filters
		 *
		 * @param {Object} source - object containing the tab scope as the modelId
		 */
		_onScopeChanged(source) {
			const scope = source.modelId;
			if (this._afi) {
				this._afi.setScope('tabScope', scope);
				this._afi.show(true);
			}
		}

		/**
		 * Method to react to the filter context updating
		 * Important for collapsed docks and filter widgets on the canvas becoming inactive
		 */
		_onFilterContextUpdated(payload) {
			payload = payload || {};
			if (payload.ignorePageContextChanged && payload.ignorePageContextChanged()) {
				return;
			}
			if (this._afi) {
				this._afi.show(true);
			}
		}
	}

	return ActiveFilterView;
});
